import mifosRepository, { MifosRepository } from "./MifosRepository";

const resource = "/datatables";
export default {
  getDataTableInfo(tableName, entityId) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resource}/${tableName}/${entityId}`);
  },

  getDataOfDataTableInfoWithFilter(tableName, entityId, columnName, columnValue) {
    const queryParams = `?parentEntityId=${entityId}&${columnName}=${columnValue}&exactMatch=true`;
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resource}/search/${tableName}${queryParams}`);
  },

  addDataTableEntry(tableName, entityId, payload) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.post(`${resource}/${tableName}/${entityId}`, payload);
  },

  updateDataTableEntryInMultiRowDataTable(tableName, entityId, rowId, payload) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.put(`${resource}/${tableName}/${entityId}/${rowId}`, payload);
  },

  updateDataTableEntry(tableName, entityId, payload) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.put(`${resource}/${tableName}/${entityId}`, payload);
  },

  getTableByDataTableName(tableName) {
    mifosRepository.setContentType("application/json");
    return MifosRepository.get(`${resource}/${tableName}`);
  }
};
